import { DocumentChangeInterface, OperationTypeEnum } from "@finway-group/shared/lib/models"
import i18n from "Shared/locales/i18n"
import { ThunkDispatchResult } from "Shared/store"

import { fetchAllCompanies } from "Shared/store/actions/company/companyActions"
import NotificationService, { NotificationTypeEnum } from "../notification.service"

const subscribeToCompanySettings = (dispatch: any, data: DocumentChangeInterface) => {
    const {
        fullDocument: { operationType },
    } = data

    if (operationType === OperationTypeEnum.INSERT || operationType === OperationTypeEnum.UPDATE) {
        dispatch(fetchAllCompanies(false))
    }
}

export const subscribeToCompanyCallbacks = (dispatch: ThunkDispatchResult, data: DocumentChangeInterface) => {
    // prettier-ignore
    const { fullDocument: { operationType } } = data;

    switch (operationType) {
        case OperationTypeEnum.DATEV_ONLINE_EXPORT_INVALID_GRANT:
            NotificationService.send(NotificationTypeEnum.ERROR, i18n.t("error:datev_online.invalid_grant.title"), i18n.t("error:datev_online.invalid_grant.message"), 0)
            dispatch(fetchAllCompanies(true))
            break
        default:
            break
    }
}

export default subscribeToCompanySettings
